 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALF_TITLE from '@/components/half_title'
 import TITLE_PAGE from '@/components/title_page'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import CONTENTS from '@/components/contents'
 import PREFACE from '@/components/preface'
 import NOTE_ON_CONVENTIONS from '@/components/note_on_conventions'
 import PART_01 from '@/components/part_01'
 import CHAPTER_01 from '@/components/chapter_01'
 import CHAPTER_02 from '@/components/chapter_02'
 import CHAPTER_03 from '@/components/chapter_03'
 import PORTRAIT_01 from '@/components/portrait_01'
 import PART_02 from '@/components/part_02'
 import CHAPTER_04 from '@/components/chapter_04'
 import CHAPTER_05 from '@/components/chapter_05'
 import CHAPTER_06 from '@/components/chapter_06'
 import CHAPTER_07 from '@/components/chapter_07'
 import CHAPTER_08 from '@/components/chapter_08'
 import PORTRAIT_02 from '@/components/portrait_02'
 import PART_03 from '@/components/part_03'
 import CHAPTER_09 from '@/components/chapter_09'
 import CHAPTER_10 from '@/components/chapter_10'
 import CHAPTER_11 from '@/components/chapter_11'
 import CHAPTER_12 from '@/components/chapter_12'
 import CHAPTER_13 from '@/components/chapter_13'
 import PORTRAIT_03 from '@/components/portrait_03'
 import PART_04 from '@/components/part_04'
 import CHAPTER_14 from '@/components/chapter_14'
 import CHAPTER_15 from '@/components/chapter_15'
 import CHAPTER_16 from '@/components/chapter_16'
 import CHAPTER_17 from '@/components/chapter_17'
 import EPILOGUE from '@/components/epilogue'
 import APPENDICES from '@/components/appendices'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import CHRONOLOGY from '@/components/chronology'
 import ABBREVIATIONS from '@/components/abbreviations'
 import NOTE_ON_DATES_AND_QUOTES from '@/components/note_on_dates_and_quotes'
 import NOTE_ON_SOURCES from '@/components/note_on_sources'
 import NOTES from '@/components/notes'
 import BIBLIOGRAPHY from '@/components/bibliography'
 import LIST_OF_MAPS_FIGURES_AND_PLATES from '@/components/list_of_maps_figures_and_plates'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/note_on_conventions",
 			"name" : "note_on_conventions",
 			"component" : NOTE_ON_CONVENTIONS
 		},
 		{
 			"path" : "/part_01",
 			"name" : "part_01",
 			"component" : PART_01
 		},
 		{
 			"path" : "/chapter_01",
 			"name" : "chapter_01",
 			"component" : CHAPTER_01
 		},
 		{
 			"path" : "/chapter_02",
 			"name" : "chapter_02",
 			"component" : CHAPTER_02
 		},
 		{
 			"path" : "/chapter_03",
 			"name" : "chapter_03",
 			"component" : CHAPTER_03
 		},
 		{
 			"path" : "/portrait_01",
 			"name" : "portrait_01",
 			"component" : PORTRAIT_01
 		},
 		{
 			"path" : "/part_02",
 			"name" : "part_02",
 			"component" : PART_02
 		},
 		{
 			"path" : "/chapter_04",
 			"name" : "chapter_04",
 			"component" : CHAPTER_04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js